import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    rootUrl: 'https://greathelp.co.jp/recruit/',
  },
  getters:{
    rootUrl(state) {
      return state.rootUrl
    },
  },
  mutations: {
    setRootUrl(state, payload) {
      state.rootUrl = payload;
    },
  },
  actions: {
    setRootUrl({
      commit
    }) {
      let rootUrl = process.env.NODE_ENV === 'production' ? "https://greathelp.co.jp/recruit" : "http://recruit.greathelp.localhost/recruit";
      commit('setRootUrl', rootUrl);
    },
  },
  modules: {
  },

  plugins: [createPersistedState()]
  
})
